import { render, staticRenderFns } from "./VariablePayment.vue?vue&type=template&id=5d4bc6f7&scoped=true&"
import script from "./VariablePayment.vue?vue&type=script&lang=js&"
export * from "./VariablePayment.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d4bc6f7",
  null
  
)

export default component.exports